// SEO-тексты всех экранов приложения.
//
// Единственный источник — Drupal: настройки metatag для страниц и ноды
// «Статьи» для материалов Какао-академии. Приложение забирает их одним
// запросом на /api/seo/data (см. src/Controller/SeoData.php). Раньше те же
// тексты лежали статикой в app/data/seo.json, и правились они руками
// в репозитории — теперь их меняет редактор в админке.
//
// При заходе по прямой ссылке теги уже стоят в исходной разметке: их
// печатает модуль metatag. Данные отсюда нужны для переходов внутри
// приложения, когда html уже отрисован (см. app/router/index.js).

const SEO_URL = '/api/seo/data';

// null — данные ещё не загружены или запрос не удался.
let seo = null;

/**
 * Загружает SEO-тексты. Вызывается один раз до монтирования приложения
 * (app/main.js): по ним router решает, существует ли статья.
 */
export const loadSeo = async () => {
  try {
    const response = await fetch(SEO_URL, {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }

    seo = await response.json();
  } catch (error) {
    // Без данных приложение работает как обычно, только теги при переходах
    // не обновляются: на странице остаются те, что пришли с сервера.
    console.error(`Не удалось загрузить ${SEO_URL}:`, error);
    seo = null;
  }
};

// Ключи страниц совпадают с именами роутов приложения — тот же список задан
// в контроллере, в SeoData::__invoke().
export const pageMeta = (name) => seo?.pages?.[name] ?? null;

// Ключ статьи — её slug (поле field_slug ноды), он же последний сегмент
// адреса: pathauto собирает алиасы по шаблону /kakao-academy/article/<slug>.
export const articleMeta = (slug) => seo?.articles?.[slug] ?? null;

/**
 * Есть ли в Drupal статья с таким slug.
 *
 * Список статей задаёт бэкенд: адрес со slug, которого нет среди нод,
 * отдаёт 404 и при прямом заходе. Пока данных нет, судить не о чем —
 * отвечаем «есть», чтобы из-за неудавшегося запроса не спрятать статью,
 * контент которой в приложении лежит.
 */
export const hasArticleMeta = (slug) => (seo ? Boolean(seo.articles?.[slug]) : true);
